<template>
  <v-card>
    <v-dialog
      v-model="isOpen"
      max-width="600px"
    >
      <v-card>
        <v-toolbar dark color="teal">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Cells</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="sort">
              <v-icon v-if='sorted === 1' small>arrow_upward</v-icon> 
              <v-icon v-else-if='sorted === -1' small>arrow_downward</v-icon> 
              <v-icon v-else small>sort</v-icon> 
              Sort
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-btn dark text v-exporttocsv="'#batterycells'">
              <v-icon small>save</v-icon> Download
            </v-btn>
          </v-toolbar-items>
          <v-toolbar-items>
            <v-btn text size="small" @click="createBattery">
              Create Battery
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-simple-table class="dialog-no-footer" id="batterycells" style="display:none">
          <template v-slot:default>
            <thead>
              <tr>
                <th>Cell Number</th>
                <th>Value</th>
                <th>Power</th>
                <th>Voltage</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cell, i) in cells" :key="i">
                <td>{{cell.number}}</td>
                <td>{{cell.value}}</td>
                <td>{{cell.power}}</td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table class="dialog-no-footer">
          <template v-slot:default>
            <thead>
              <tr>
                <th>#</th>
                <th>Value</th>
                <th>Power</th>
                <th>Voltage</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(cell, i) in cells" :key="i">
                <td>{{cell.number}}</td>
                <td>{{cell.value}}</td>
                <td>{{cell.power}}</td>
                <td>
                  <v-text-field
                    dense
                    hide-details
                    solo
                    v-model="cell.voltage"
                    type="number"
                    @keyup="updateCell(cell)"
                  ></v-text-field>
                </td>
                <td>
                  <v-btn @click="replaceCell(cell)" :loading="waiting">Replace Cell</v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { balancedcells } from "@/api";
import { debounce } from "lodash";
export default {
  name: "BalanceBatteryCellsDialog",
  props: ['isOpen', 'cells', 'closeDialog', 'createBattery', 'replaceCell', 'sort', 'sorted'],
  data: () => ({
    waiting: false,
  }),
  methods: {
    updateCell: debounce(async function (cell) {
      try {
        this.waiting = true;
        await balancedcells.updateVoltage(cell.id, cell.voltage);
      } catch (error) {
        console.errot('error', error);  
      }
      this.waiting = false;
    }, 250)
  }
};
</script>